/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import logo from "../../assets/images/icragee.png";
const Footer = () => {
  return (
    <div className="bg-cyan-600 flex sm:flex-row flex-col-reverse md:items-center justify-between sm:px-20 px-8 py-10">
      <div className="flex flex-col">
        <div className="text-3xl font-bold text-white mb-4">SHARE</div>
        <div className="flex flex-row gap-4">
          <svg
            width="30"
            height="30"
            viewBox="0 0 50 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M41.7492 17.25V13L24.9992 23.5L8.24916 13V17.25L24.9992 27.5L41.7492 17.25ZM41.7492 8.75C42.8325 8.75 43.7908 9.20833 44.6242 10.125C45.4575 11.0417 45.8325 12 45.7492 13V38C45.7492 39.0833 45.3742 40.0417 44.6242 40.875C43.8742 41.7083 42.9158 42.1667 41.7492 42.25H8.24916C7.16582 42.25 6.20749 41.7917 5.37416 40.875C4.54082 39.9583 4.16582 39 4.24916 38V13C4.24916 11.9167 4.62416 10.9583 5.37416 10.125C6.12416 9.29167 7.08249 8.83333 8.24916 8.75H41.7492Z"
              fill="white"
            />
          </svg>
          <svg
            width="30"
            height="30"
            viewBox="0 0 25 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.6657 16.9987H24.999V25.332H16.6657V44.6654H8.33236V25.332H-0.000976562V16.9987H8.33236V13.4987C8.33236 10.1654 9.33236 5.9987 11.3324 3.66536C13.499 1.4987 15.999 0.332031 19.1657 0.332031H24.999V8.66536H19.1657C17.6657 8.66536 16.6657 9.66536 16.6657 11.1654V16.9987Z"
              fill="white"
            />
          </svg>
          <svg
            width="30"
            height="30"
            viewBox="0 0 50 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M44.1657 6.66797C46.3324 5.33463 47.8324 3.33464 48.6657 1.0013C46.3324 2.16797 44.1657 3.0013 41.999 3.33464C40.1657 1.33463 37.6657 0.167969 34.6657 0.167969C31.8324 0.167969 29.3324 1.16797 27.3324 3.16797C25.3324 5.16797 24.3324 7.66797 24.3324 10.5013C24.3324 11.3346 24.499 12.0013 24.6657 12.668C16.1657 12.5013 8.99902 8.83463 3.49902 2.0013C2.49902 3.66797 1.99902 5.5013 1.99902 7.16797C1.99902 10.8346 3.66569 13.668 6.66569 15.8346C4.83236 15.668 3.33236 15.168 1.99902 14.5013C1.99902 17.0013 2.83236 19.168 4.33236 21.168C5.83236 23.0013 7.83236 24.168 10.1657 24.668C9.33236 24.8346 8.49902 25.0013 7.49902 25.0013C6.66569 25.0013 5.99902 25.0013 5.66569 24.8346C6.33236 26.8346 7.49902 28.668 9.16569 29.8346C10.999 31.168 12.999 31.8346 15.1657 32.0013C11.499 34.8346 7.33236 36.3346 2.49902 36.3346C1.33236 36.3346 0.499023 36.3346 -0.000976562 36.168C4.66569 39.3346 9.99902 40.8346 15.8324 40.8346C21.6657 40.8346 26.999 39.3346 31.499 36.3346C36.1657 33.3346 39.499 29.5013 41.6657 25.168C43.8324 20.8346 44.8324 16.3346 44.8324 11.668V10.3346C46.999 8.83463 48.6657 7.0013 49.999 5.0013C48.1657 5.83464 46.1657 6.33464 44.1657 6.66797Z"
              fill="white"
            />
          </svg>
        </div>
      </div>
      <div>
        <img src={logo} style={{ height: "200px" }} />
      </div>
      <div className="flex flex-col">
        <div className="sm:text-3xl text-2xl font-bold text-white mb-4">
          CONTACT US
        </div>
        <div className="flex flex-row text-white text-lgfont-medium">
          8icragree@iitg.ac.in
        </div>
      </div>
    </div>
  );
};

export default Footer;
